import {Component, OnInit} from '@angular/core';
import {WebhookListAction} from './WebhookListAction';
import {ApiResponseModel} from '../../data/model/ApiResponseModel/api-response.model';
import {WebhookLogModel} from '../../data/model/WebhookLogModel/webhook_log.model';
import {DataManagerService} from '../../data/services/DataManager/data-manager.service';
import {EventModel} from '../../data/model/EventModel/Event.model';
import {ActivatedRoute, Router} from '@angular/router';
import {AppConstants} from '../../shared/constants/app-constants';

@Component({
    selector: 'app-webhook-log-details',
    templateUrl: './webhook-log-details.component.html',
    styleUrls: ['./webhook-log-details.component.css'],
    standalone: false
})

export class WebhookLogDetailsComponent  extends WebhookListAction implements OnInit {

  dataManager: DataManagerService;
  webhookData: WebhookLogModel;
  constructor(dataManager: DataManagerService, router: Router, route: ActivatedRoute) {
    super();
    this.dataManager = dataManager;
    this.errorMsg = null;
    this.router = router;
    this.route = route;
    this.webhookData = new WebhookLogModel();
    if (this.fetchIdFromRouteQueryParams()) {
      this.route.queryParams.subscribe((params) => {
        this._webhookListUrl = AppConstants.BASE_URL + AppConstants.SERVICE_NAME_WEBHOOK_LOG_DETAIL + '/' + params['id'];
      });
      this.getWebhookListData();
    }

  }
  ngOnInit() {
  }
  protected passWebhookList(wphResponse) {
    this.loadFlag = false;
    this.webhookData = new WebhookLogModel(wphResponse.data);
  }
  protected passError(error: any) {
    this.loadFlag = false;
  }

}
